import styled from 'styled-components';

export const ChannelDescriptionModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
